import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../utils/getBrand';

const isCelebrity = getBrand().id === 'cel';

const useStyles = makeStyles((Theme) => ({
  gridContainer: {
    minHeight: '82%',
    padding: '0px 16px 30px',
    flexDirection: 'column',
    [Theme.breakpoints.up('lg')]: {
      maxWidth: '1080px',
      margin: '0 auto',
      minHeight: '87%',
      paddingLeft: 0,
      paddingRight: 0,
    },
    [Theme.breakpoints.up('sm')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [Theme.breakpoints.up('md')]: {
      paddingLeft: 40,
      paddingRight: 40,
    },
    [Theme.breakpoints.up('xl')]: {
      padding: 0,
    },
  },

  notificationBanner: {
    [Theme.breakpoints.up('md')]: {
      paddingBottom: '20px',
    },
  },
  desktopBannerIcon: {
    marginTop: '40px',
    marginBottom: '40px',
    [Theme.breakpoints.up('md')]: {
      margin: '0',
    },
  },

  paymetBreadcrumbs: {
    padding: '0 !important',
  },
  paymentsLayout: {
    position: 'relative',
    marginLeft: 52,
    marginRight: 76,
    [Theme.breakpoints.down('lg')]: {
      marginLeft: 20,
      marginRight: 29,
    },
    [Theme.breakpoints.down('md')]: {
      marginLeft: 32,
      marginRight: 32,
    },
    [Theme.breakpoints.down('sm')]: {
      marginLeft: 20,
      marginRight: 20,
    },
  },

  paymentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100%',
    fontFamily: Theme.typography.base.regular,
    maxWidth: 1440,
  },
  reviewAndPay: {
    marginTop: '57px',
    minHeight: '351px',
    background: Theme.palette.white,
    [Theme.breakpoints.down('lg')]: {
      marginTop: '50px',
    },
    [Theme.breakpoints.down('md')]: {
      marginTop: '30px',
    },
  },
  checkout: {
    minHeight: '407px',
    background: Theme.palette.white,
    marginTop: '60px',
  },
  paymentCardWrapper: {
    paddingLeft: '180px',
    paddingRight: '180px',
    [Theme.breakpoints.down('lg')]: {
      paddingLeft: '50px',
      paddingRight: '50px',
    },
    [Theme.breakpoints.down('sm')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  paymentCard: {
    borderRadius: '5px',
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    padding: '40px',
  },
  paymentWrapper: {
    display: 'inline-flex',
    padding: '0',
    margin: '0',
    width: '100%',
    height: '100%',
  },
  filterSectionSummary: {
    padding: '40px 20px',
    height: '100%',
    background: '#FFF',
    borderBottomRightRadius: '0',
    [Theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bodyWrapperSection: {
    minWidth: '380px',
    [Theme.breakpoints.down('lg')]: {
      minWidth: '340px',
    },
    [Theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  cardTitleCheckoutPayment: {
    fontSize: '36px',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    display: 'flex',
    [Theme.breakpoints.down('lg')]: {
      fontSize: '30px',
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: '24px',
    },
  },

  tooltipWrapper: {
    fontSize: Theme.typography.size[2],
    lineHeight: Theme.typography.size[4],
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
    padding: '10px 0',
  },

  tootipTilte: {
    fontFamily: Theme.typography.base.semiBold,
    paddingBottom: 20,
    color: Theme.palette.primary.main,
  },
  tooltipRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 15,
    '& span:first-child': {
      paddingRight: '10px',
    },

    '& span:last-child': {
      fontFamily: Theme.typography.base.semiBold,
    },
  },

  tooltipTotal: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: Theme.typography.base.semiBold,
    '& span:first-child': {
      paddingRight: '10px',
    },
  },

  tooltipLabel: {
    display: 'flex',
    alignItems: 'center',
  },

  tooltipAmount: {
    color: Theme.palette.text.brand,
    fontFamily: Theme.typography.base.semiBold,
    cursor: 'pointer',
  },
  infoIcon: {
    marginLeft: '8px',
    color: Theme.palette.primary.light,
    width: 16,
    height: 16,
    cursor: 'pointer',
  },

  paymentSummaryLabel: {
    '& span': {
      marginLeft: '5px',
      color: Theme.palette.text.brand,
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[3],
    },
  },

  paymentFooter: {
    marginTop: 0,
    padding: '20px 30px',
    [Theme.breakpoints.down('sm')]: {
      marginTop: '-8%',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '16px 50px',
    },
    [Theme.breakpoints.up('lg')]: {
      paddingRight: 'calc((100vw - 974px)/ 2)',
      paddingLeft: 'calc((100vw - 974px)/ 2)',
    },
    [Theme.breakpoints.up('xl')]: {
      paddingRight: 'calc((100vw - 1080px)/ 2)',
      paddingLeft: 'calc((100vw - 1080px)/ 2)',
    },

    '& button': {
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[1],
      textTransform: `${isCelebrity ? 'uppercase' : 'initial'}`,
      width: '100%',
      padding: '8px 20px',
      borderRadius: `${isCelebrity ? '1px' : '4px'}`,

      '&.MuiButton-containedPrimary': {
        backgroundColor: `${
          isCelebrity ? Theme.palette.primary.main : Theme.palette.primary.light
        }`,
      },

      '& .MuiButton-label': {
        whiteSpace: 'nowrap',
      },

      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[2],
        width: 'auto',
        padding: '13px 30px',
      },

      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[3],
      },

      '&.Mui-disabled': {
        backgroundColor: `${Theme.palette.gray[500]}`,
        color: Theme.palette.gray[200],
      },
    },

    '& p': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
    },
  },
  cardHeaderCheckoutPayment: {
    paddingTop: '0',
    '& .MuiTypography-paragraph': {
      marginBottom: '0',
    },

    '& .MuiTypography-body1': {
      marginBottom: '0',
    },
  },
  summaryContainer: {
    display: 'none',
    [Theme.breakpoints.down('md')]: {
      display: 'grid',
    },
  },
  searchWrapperCardContent: {
    padding: '0px',
  },
  airFooter: {
    padding: '20px 0px !important',
    margin: '20px 0px',
    [Theme.breakpoints.up('md')]: {
      margin: '30px 0px',
    },
    '& > div': {
      padding: '0px',
    },
  },
  stickyMainFooter: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    position: 'sticky',
    margin: '0',
    bottom: '0',
    zIndex: 1,

    '&.errorBorder > footer': {
      borderTop: `3px solid ${Theme.palette.error.main}`,
      boxShadow: '0px -2px 4px 0px rgba(6, 21, 86, 0.15)',
    },
  },
  progressLineContainer: {
    marginBottom: '20px',

    [Theme.breakpoints.up('md')]: {
      marginBottom: '30px',
    },
  },
  labelsStickyFooter: {
    marginLeft: '8px',
    [Theme.breakpoints.only('md')]: {
      maxWidth: '244px',
    },
  },

  errorMessage: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    '& p': {
      margin: '0px 0px 0px 8px',
      color: `${Theme.palette.error.main}`,
      fontSize: Theme.typography.size[2],
      fontWeight: '600',
      lineHeight: '120%',
    },
  },
  checkboxOpenModalButton: {
    color: Theme.palette.primary.light,
    cursor: 'pointer',
    fontFamily: Theme.typography.base.semiBold,
  },
  checkboxIconSize: {
    width: '16px',
    height: '16px',
    [Theme.breakpoints.up('lg')]: {
      width: '24px',
      height: '24px',
    },
  },
}));

export default useStyles;
